(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var BaseModel = require('cf-base-model')
  , schemata = require('../../../service/itinerary/schema')()
  , EntryCollection = require('../collections/entry')

module.exports = BaseModel.extend(
  { idAttribute: '_id'

  , schemata: schemata

  , url: function () {
      var url = window.config.apiUrl + '/itinerary'
      if (this.id) {
        url += '/' + this.id
      }
      return url
    }

  , defaults: function () {
      var data = schemata.makeDefault()
      delete data.dateCreated
      return data
    }

  , initialize: function () {
      this.set('entries', new EntryCollection(this.get('entries')))
    }
  })

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/itinerary/models/itinerary.js","/components/admin/itinerary/models")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvYWRtaW4vaXRpbmVyYXJ5L21vZGVscy9pdGluZXJhcnkuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJ2YXIgQmFzZU1vZGVsID0gcmVxdWlyZSgnY2YtYmFzZS1tb2RlbCcpXG4gICwgc2NoZW1hdGEgPSByZXF1aXJlKCcuLi8uLi8uLi9zZXJ2aWNlL2l0aW5lcmFyeS9zY2hlbWEnKSgpXG4gICwgRW50cnlDb2xsZWN0aW9uID0gcmVxdWlyZSgnLi4vY29sbGVjdGlvbnMvZW50cnknKVxuXG5tb2R1bGUuZXhwb3J0cyA9IEJhc2VNb2RlbC5leHRlbmQoXG4gIHsgaWRBdHRyaWJ1dGU6ICdfaWQnXG5cbiAgLCBzY2hlbWF0YTogc2NoZW1hdGFcblxuICAsIHVybDogZnVuY3Rpb24gKCkge1xuICAgICAgdmFyIHVybCA9IHdpbmRvdy5jb25maWcuYXBpVXJsICsgJy9pdGluZXJhcnknXG4gICAgICBpZiAodGhpcy5pZCkge1xuICAgICAgICB1cmwgKz0gJy8nICsgdGhpcy5pZFxuICAgICAgfVxuICAgICAgcmV0dXJuIHVybFxuICAgIH1cblxuICAsIGRlZmF1bHRzOiBmdW5jdGlvbiAoKSB7XG4gICAgICB2YXIgZGF0YSA9IHNjaGVtYXRhLm1ha2VEZWZhdWx0KClcbiAgICAgIGRlbGV0ZSBkYXRhLmRhdGVDcmVhdGVkXG4gICAgICByZXR1cm4gZGF0YVxuICAgIH1cblxuICAsIGluaXRpYWxpemU6IGZ1bmN0aW9uICgpIHtcbiAgICAgIHRoaXMuc2V0KCdlbnRyaWVzJywgbmV3IEVudHJ5Q29sbGVjdGlvbih0aGlzLmdldCgnZW50cmllcycpKSlcbiAgICB9XG4gIH0pXG4iXX0=